
const GeojsonLayer = (data) => {
	// TODO 
	// const selectedIds = new Set(selection);
	// const ffeatures = data['features'].filter(f => selectedIds.has(f.properties.id));
	const ffeatures = data['features'].filter(f => f.geometry.type === 'LineString' || f.geometry.type === 'MultiLineString')
	return {
		id: 'line-layer-selected',
		type: 'line',
		source: {
			type: "geojson",
			data: {type: 'FeatureCollection', features: ffeatures},
		},
		// filter:  ["any", ...selection.map(id => ["==", "id", id])],
		filter: ['==', 'id', ''],
		paint: {
			'line-width': 3,
			'line-color': "#68daf9"
		}
	}
}

export default GeojsonLayer;